import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFilterStore } from "../stores/FilterStore";

export const useHandleCountyUrlChanges = () => {
  const { county, setCounty } = useFilterStore(["county", "setCounty"]);

  const { pathname } = useLocation();

  useEffect(() => {
    const isOnAreaPage = pathname.split("/")?.[1] === "areas";
    if (!isOnAreaPage) return;

    const urlCounty = pathname.split("/")?.[2];
    if (!urlCounty) return;

    if (urlCounty !== county) {
      setCounty(urlCounty);
    }
  }, [county, pathname, setCounty]);
};
